import { makeStyles } from "tss-react/mui";

const useIconFieldStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: "inherit",
    width: "100%",
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    color: theme.palette.text.primary,
  },
  disabled: {
    color: theme.palette.grey[500],
  },
  greenText: {
    color: theme.palette.primary.main,
  },
  noMargin: {
    margin: 0,
  },
}));

export default useIconFieldStyles;
